const { Input } = require("@chakra-ui/react");

export function NumberComponent({ column, onChange, ...rest }) {
  return (
    <Input type="number" id={column.fieldName} onChange={onChange} {...rest} />
  )
}
